import React from 'react';
import Form from './form';
import Input from './input';
import {_} from '../locales/gettext';


export default class TestScan extends Form {

    static defaultProps = {
        submitText: _('Continue'),
        title: _('Test Scan'),
    };

    render() {
        let inputs = <div>
            <Input
                ref="code"
                placeholder={_('Code')}
                required={false}
                check={this.state.submitCheck}
                convertChars={true}
                handScan={true}
                handScanOpen={true}
                handScanParseJSON={true}
                handScanTimeout={0}
                onScanSubmit={() => this.submit()}
            />
        </div>;

        return this.getForm(inputs);
    }

}
